import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses';
import {
  elisaMobiilivarmenneContentMsg,
  elisaMobiilivarmenneLinkMsg,
  elisaMobiilivarmenneMsg,
  elisaMobiilivarmenneSmallHeaderMsg,
  t,
} from '../../common/i18n';
import { Grid } from '../Grid/Grid.js';

import './Mobiilivarmenne.scss';

export const Mobiilivarmenne = () => (
  <Grid>
    <CL.Grid>
      <CL.GridRow>
        <CL.GridCol colWidthXS={12} colWidthS={7} colWidthL={7} className={dsClass.PADDING_RIGHT_3}>
          <h3>{t.ELMO(elisaMobiilivarmenneMsg)}</h3>
          <h4>{t.B75I(elisaMobiilivarmenneSmallHeaderMsg)}</h4>
          <p>{t.SX92(elisaMobiilivarmenneContentMsg)}</p>
        </CL.GridCol>
        <CL.GridCol colWidthXS={12} colWidthS={5} colWidthL={5} className="of-mobiilivarmenne--link-block">
          <CL.LinkBlock
            icon={<CL.Icon icon="external-link" />}
            border="top"
            onClick={() => window.open('https://yrityksille.elisa.fi/ohjeet/mobiilivarmenne', '_blank')}
          >
            {t.MBXP(elisaMobiilivarmenneLinkMsg)}
          </CL.LinkBlock>
        </CL.GridCol>
      </CL.GridRow>
    </CL.Grid>
  </Grid>
);
